import { combineReducers } from 'redux';

import screenReducer from './reducers/screenReducer';
import gameDetailsReducer from './reducers/gameDetailsReducer';
import levelReducer from './reducers/levelReducer';
import screenPositionReducer from './reducers/screenPositionReducer';
import practiceReducer from './reducers/practiceReducer';
import projectorReducer from './reducers/projectorReducer';
import goblinReducer from './reducers/goblinReducer';
import toastReducer from './reducers/toastReducer';

// keeping the reducer collection as a separate exported object enables us
// to do some light test automation on every reducer.
// see ./reducers/__tests__/reducerRejections.test.js
// for more details.
export const reducerCollection = {
  screen: screenReducer,
  gameDetails: gameDetailsReducer,
  level: levelReducer,
  screenPosition: screenPositionReducer,
  practice: practiceReducer,
  projectorReducer,
  goblinReducer,
  toastReducer,
};

const reducers = combineReducers({ ...reducerCollection });

export default reducers;
